import React, { useEffect, useState } from 'react';
import {
    AppBar,
    Grid,
    Tab,
    Tabs,
    Toolbar,
    Typography,
} from '@material-ui/core';
import logo from './logo_cemca.png';
import './App.css';
import { useDispatch, useSelector } from 'react-redux';
import Notifier from './components/Notifier';
import V1Graph from './components/V1Graph';
import V2Graph from './components/V2Graph';
import V3Graph from './components/V3Graph';
import Arbitary from './Arbitary';
import DijAutIns from './DijAutIns';
import DijkstrasAutomated from './DijkstrasAutomated';
import DijstrasTutorial from './DijstrasTutorial';
import DijTutIns from './DijTutIns';
import { actions as uiActions } from './store/slices/ui';
import { actions as v1GraphActions } from './store/slices/v1Graph';
import { actions as v2GraphActions } from './store/slices/v2Graph';
import { actions as v3GraphActions } from './store/slices/v3Graph';

const App = () => {
    const activeGraphId = useSelector((state) => state.ui.activeGraphId);
    const dispatch = useDispatch();

    const handleTabClick = (event, graphId) => {
        dispatch(uiActions.setActiveGraph({ graphId }));
    };

    useEffect(() => {
        dispatch(v1GraphActions.reset());
        dispatch(v2GraphActions.reset());
        dispatch(v3GraphActions.reset());
    }, [activeGraphId]);

    return (
        <div className="root">
            <Notifier />
            <AppBar className="appbar" position="relative">
                <Toolbar>
                    <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <Typography variant="h6">
                                Shortest Path using Dynamic Programming
                            </Typography>
                        </Grid>
                        <Grid item></Grid>
                    </Grid>
                </Toolbar>
                <Tabs
                    value={activeGraphId}
                    onChange={handleTabClick}
                    scrollableX
                    variant="scrollable"
                    orientation="horizontal"
                >
                    <Tab label="Home" value={1} />
                    <Tab label="Arbitrary" value={2} />
                    <Tab label="Using Topological Sort" value={3} />
                    <Tab label="Using Topological (Semi-automated)" value={4} />
                    <Tab label="Using Topological (Automated)" value={5} />
                    <Tab label="Dijkstra's Algorithm" value={6} />
                    <Tab label="Dijkstra's (Automated)" value={7} />
                </Tabs>
            </AppBar>
            {activeGraphId === 1 && (
                <div className="home-div">
                    <p className="home-top">
                        This page lists the transition systems that lead to the
                        Single source shortest path using dynamic programming
                        through successive refinement of systems.
                    </p>
                    <ol className="home-list">
                        <li>Arbitrary </li>
                        <li>Using Topological Sort </li>
                        <li>Using Topological (Semi-automated) </li>
                        <li>Using Topological (Automated) </li>
                        <li>Dijkstra's Algorithm</li>
                        <li>Dijkstra's (Automated)</li>
                    </ol>
                    <div class="home-footer">
                        <h2>
                            The development of this lab has been supported by{' '}
                            <a
                                href="https://www.cemca.org"
                                target="_blank"
                                class="text-blue-800"
                            >
                                CEMCA
                            </a>{' '}
                        </h2>
                        <img
                            src={logo}
                            title="Development partly supported by CEMCA"
                            class="px-2 h-16 inline"
                        />
                    </div>
                </div>
            )}
            {activeGraphId === 2 && <Arbitary />}
            {activeGraphId === 3 && <V1Graph />}
            {activeGraphId === 4 && <V2Graph />}
            {activeGraphId === 5 && <V3Graph />}

            {(activeGraphId === 6 || activeGraphId === 7) && (
                <div className="content">
                    {activeGraphId === 6 && <DijTutIns />}
                    {activeGraphId === 7 && <DijAutIns />}
                    <div className="right-div">
                        {activeGraphId === 6 && <DijstrasTutorial />}
                        {activeGraphId === 7 && <DijkstrasAutomated />}
                    </div>
                </div>
            )}
            {activeGraphId !== 1 && (
                <div className="copyright">
                    <h3>
                        Copyright © 2022, algodynamics.io | The development of
                        this experiment has been supported by{' '}
                        <a href="https://www.cemca.org" target="_blank">
                            {' '}
                            CEMCA{' '}
                        </a>
                    </h3>
                </div>
            )}
        </div>
    );
};

export default App;
